import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { createVehicle } from "adminApi/TransportFacilityApi/VehicleApi.js";
import { validateForm } from "utils/validation";
import { VehicleRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/VehicleFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const AddVehicle = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    const {
        values,
        errors,
        handleChange,
        setErrors,
    } = useFormChange(initialValues, VehicleRules);

    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await createVehicle({ data: formValues });
        },

        (vals) => {
            const err = validateForm(vals, VehicleRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Vehicle Added Successfully"
    );

    return (
        <PageBody
            headerchildren={<HeadingOne>Add Vehicle</HeadingOne>}
            onSubmit={(e) => handleSubmit(e, values)}
        >
            {loading && <Spinner isSpinner />}
            {formdata.map((field) => (
                <FormInput
                    key={field.name}
                    field={field}
                    value={values[field.name] || ""}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            ))}

            <FormSubmitButton
                label="Create"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddVehicle;
